import {forEach} from "../../js/helpers";
import {break_sm} from "../../js/constants";

forEach(document.querySelectorAll('.itemSm'), item => {
  if (window.innerWidth > break_sm) return;

  const sizes = item.querySelector('.itemSm__sizes');
  const side = item.querySelector('.itemSm__side');
  side.insertBefore(sizes, side.firstChild);
});